import PropTypes from 'prop-types';
import viewStatuses from './viewStatus.js';

export const viewStatus = PropTypes.oneOf(Object.values(viewStatuses));

export default PropTypes.shape({
    acceptanceTimeLimitInMinutes: PropTypes.number,
    feePercentage: PropTypes.number.isRequired,
    itemType: PropTypes.string.isRequired,
    itemId: PropTypes.string.isRequired,
    maxAmount: PropTypes.number,
    viewStatus: viewStatus.isRequired,
});



// WEBPACK FOOTER //
// ./safeTrade/safeTradePropTypes.js